export default "__VITE_ASSET__628157f7__"